export enum FirestoreEnvironment {
  PROD = "prod",
  DEV = "dev",
  CURRENT = "current",
}
